module.exports = __webpack_public_path__ + "static/media/Structure.727d276f.ogg";